export default {
  apiKey: 'AIzaSyBbPKr0P_iy-ybWh0Aq3YJhHWFTrJp1ntw',
  authDomain: 'hack-now-submission.firebaseapp.com',
  databaseURL: 'https://hack-now-submission.firebaseio.com',
  projectId: 'hack-now-submission',
  storageBucket: 'hack-now-submission.appspot.com',
  messagingSenderId: '875874390196',
  appId: '1:875874390196:web:346143e1fff9e216a207e1',
  measurementId: 'G-DNS8CG3LQD'
}
